import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, CardBody, Form, Input, Label, Button, Alert } from 'reactstrap';
import { usePocketBase } from '../../PocketBaseContext';

const ProfilePage = () => {
    const pb = usePocketBase();
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const [formData, setFormData] = useState({
        username: '',
        name: '',
        email: '',
        oldPassword: '',
        password: '',
        passwordConfirm: ''
    });

    // İlk yükleme için useEffect
    useEffect(() => {
        const currentUser = pb.authStore.model;
        
        if (currentUser) {
            // Kullanıcı varsa state'leri güncelle
            setUser(currentUser);
            setFormData(prev => ({
                ...prev,
                username: currentUser.username || '',
                name: currentUser.name || '',
                email: currentUser.email || ''
            }));
        }
        
        setLoading(false);
    }, []); // Boş dependency array

    // Form değişiklik handler'ı
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    // Form gönderme handler'ı
    const handleProfileUpdate = async (e) => {
        e.preventDefault();
        setError(null);
        setSuccess(null);
        setLoading(true);

        try {
            const updateData = {};

            // Sadece değişen alanları ekle
            if (formData.username !== user.username) updateData.username = formData.username;
            if (formData.name !== user.name) updateData.name = formData.name;
            if (formData.email !== user.email) updateData.email = formData.email;

            // Şifre alanlarını kontrol et
            if (formData.oldPassword && formData.password && formData.passwordConfirm) {
                updateData.oldPassword = formData.oldPassword;
                updateData.password = formData.password;
                updateData.passwordConfirm = formData.passwordConfirm;
            }

            // Güncelleme yapılacak veri varsa
            if (Object.keys(updateData).length > 0) {
                const record = await pb.collection('users').update(user.id, updateData);
                setUser(record);
                setSuccess('Profil başarıyla güncellendi');
                
                // Şifre alanlarını temizle
                setFormData(prev => ({
                    ...prev,
                    oldPassword: '',
                    password: '',
                    passwordConfirm: ''
                }));
            }
        } catch (err) {
            setError(err.message || 'Profil güncellenirken bir hata oluştu');
            console.error('Update error:', err);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="page-content">
                <Container fluid>
                    <div className="text-center">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Yükleniyor...</span>
                        </div>
                    </div>
                </Container>
            </div>
        );
    }

    return (
        <div className="page-content">
            <Container fluid>
                <Row className="justify-content-center">
                    <Col lg={8}>
                        <Card>
                            <CardBody>
                                <div className="mb-4">
                                    <h4 className="card-title mb-0">Profil Bilgilerim</h4>
                                    <div className="text-muted">Hesap bilgilerinizi buradan güncelleyebilirsiniz</div>
                                </div>

                                {error && (
                                    <Alert color="danger" className="mb-4">
                                        {error}
                                    </Alert>
                                )}

                                {success && (
                                    <Alert color="success" className="mb-4">
                                        {success}
                                    </Alert>
                                )}

                                <Form onSubmit={handleProfileUpdate}>
                                    <Row>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <Label className="form-label" htmlFor="username">
                                                    Kullanıcı Adı
                                                </Label>
                                                <Input
                                                    type="text"
                                                    className="form-control"
                                                    id="username"
                                                    name="username"
                                                    value={formData.username}
                                                    onChange={handleInputChange}
                                                    required
                                                />
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <Label className="form-label" htmlFor="name">
                                                    İsim
                                                </Label>
                                                <Input
                                                    type="text"
                                                    className="form-control"
                                                    id="name"
                                                    name="name"
                                                    value={formData.name}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                        </Col>
                                    </Row>

                                    <div className="mb-3">
                                        <Label className="form-label" htmlFor="email">
                                            E-posta Adresi
                                        </Label>
                                        <Input
                                            type="email"
                                            className="form-control"
                                            id="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>

                                    <div className="border-top pt-4 mt-4">
                                        <h5 className="card-title mb-4">Şifre Değiştirme</h5>
                                        
                                        <Row>
                                            <Col md={12}>
                                                <div className="mb-3">
                                                    <Label className="form-label" htmlFor="oldPassword">
                                                        Mevcut Şifre
                                                    </Label>
                                                    <Input
                                                        type="password"
                                                        className="form-control"
                                                        id="oldPassword"
                                                        name="oldPassword"
                                                        value={formData.oldPassword}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label className="form-label" htmlFor="password">
                                                        Yeni Şifre
                                                    </Label>
                                                    <Input
                                                        type="password"
                                                        className="form-control"
                                                        id="password"
                                                        name="password"
                                                        value={formData.password}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label className="form-label" htmlFor="passwordConfirm">
                                                        Yeni Şifre (Tekrar)
                                                    </Label>
                                                    <Input
                                                        type="password"
                                                        className="form-control"
                                                        id="passwordConfirm"
                                                        name="passwordConfirm"
                                                        value={formData.passwordConfirm}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>

                                    <div className="text-end mt-4">
                                        <Button type="submit" color="primary" disabled={loading}>
                                            {loading ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                    Güncelleniyor...
                                                </>
                                            ) : (
                                                'Profili Güncelle'
                                            )}
                                        </Button>
                                    </div>
                                </Form>
                            </CardBody>
                        </Card>

                        {user?.role === 'admin' && (
                            <Card>
                                <CardBody>
                                    <div className="mb-4">
                                        <h4 className="card-title mb-0">Hesap Bilgileri</h4>
                                        <div className="text-muted">Hesabınızla ilgili detaylı bilgiler</div>
                                    </div>

                                    <Row>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <Label className="form-label text-muted">Kullanıcı ID</Label>
                                                <div className="fw-medium">{user.id}</div>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <Label className="form-label text-muted">Rol</Label>
                                                <div className="fw-medium">{user.role}</div>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <Label className="form-label text-muted">Hesap Oluşturma</Label>
                                                <div className="fw-medium">
                                                    {new Date(user.created).toLocaleString('tr-TR')}
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <Label className="form-label text-muted">Son Güncelleme</Label>
                                                <div className="fw-medium">
                                                    {new Date(user.updated).toLocaleString('tr-TR')}
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        )}
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default ProfilePage;